import { render, staticRenderFns } from "./DialogPageBook.vue?vue&type=template&id=70a2bec9&scoped=true&"
import script from "./DialogPageBook.vue?vue&type=script&lang=js&"
export * from "./DialogPageBook.vue?vue&type=script&lang=js&"
import style0 from "./DialogPageBook.vue?vue&type=style&index=0&id=70a2bec9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a2bec9",
  null
  
)

export default component.exports